<div>
        <p-header>

        </p-header>
    `   <div class="row">
            <div class="col-md-12 text-center my-2">
            <p-message [(value)]="msgs"></p-message>
                <!-- <p-message *ngIf="msg!=''" severity="info" [text]="msg"></p-message> -->
            </div>
            <div class="col-md-6">
            
                <ul class="maap-modal-list">
                    <li> <span class="maap-title">Employee Name:</span><span
                            class="maap-title-value"></span>{{isDeId(selectedRow?.employeeName)}} </li>
                    <li> <span class="maap-title">User Group:</span><span class="maap-title-value"></span>{{selectedRow?.userGroup}}
                    </li>
                    <li> <span class="maap-title">Lan ID:</span><span class="maap-title-value"></span> {{isDeId(selectedRow?.lanId)}}  </li>
                    <li> <span class="maap-title">Stock Area:</span><span class="maap-title-value"></span> {{selectedRow?.bedDev}}</li>
                    <li> <span class="maap-title">Follow Up:</span><span class="maap-title-value"></span>{{selectedRow?.followUp}}
                    </li>
                    <!-- <li> <span class="maap-title">ToTal Var:</span><span class="maap-title-value"> {{selectedRow.highRisk+selectedRow.highModRisk+selectedRow.lowRisk+selectedRow.modRisk+selectedRow.modRisk}}</span>
                    </li> -->
                    <li> <span class="maap-title">Date/Time:</span><span class="maap-title-value"></span>{{formatDateCustom(selectedRow.varDateString)}} </li>

                </ul>

                <hr>
                <ul class="maap-modal-list">
                    <li> <span class="maap-title">Assay Number :</span><span class="maap-title-value">
                           </span> </li>
                    <li><span class="maap-title">Process Date:</span><span class="maap-title-value"> </span> </li>
                    <li> <span class="maap-title">Assay Risk Score:</span><span class="maap-title-value"> </span> </li>


                </ul>


            </div>
            <div class="col-md-6">
                <div class="form-group">
                    <h4  class="maap-title-2">Update Status</h4>
                    <p-floatlabel class="w-full md:w-56" variant="on">
                        <p-select 
                            [options]="followups"
                            [(ngModel)]="comment" 
                            [filter]="true" 
                            placeholder="Update Follow Up"
                            [styleClass]="'change-status-dropdown w-100'">
                            <ng-template let-item pTemplate="selectedItem">
                                <span style="vertical-align:middle; margin-left: .5em">{{item.label}}</span>
                            </ng-template>
                            <ng-template let-followup pTemplate="item">
                                <div class="ui-helper-clearfix" style="position: relative;height: 25px;">
                                    <div style="float:center;margin-top:4px">
                                        {{followup.label}}
                                    </div>
                                </div>
                            </ng-template>
                        </p-select>
                        <label for="followup">Follow Up Status</label>
                    </p-floatlabel>
                </div>

                <h4  class="maap-title-2">History</h4>

                <div class="history-content">
                    <div *ngFor="let comment of comments">
                        <p>{{comment["createdAt"]}} </p>
                        <p>{{comment["status"]}}</p>
                    </div>
                </div>

            </div>
        </div> 
        <p-footer class="float-right">
            <button (click)="closeDialog()" type="button"  icon="pi pi-check" class="btn btn-sm btn-light" label="Yes">Cancel</button>
            <button (click)="submit()" type="button"  icon="pi pi-times" class="btn btn-sm btn-light ml-2" label="No">Submit</button>
        </p-footer>

</div>
